import { render } from "./LogOut.vue?vue&type=template&id=5dedb299&scoped=true"
import script from "./LogOut.vue?vue&type=script&lang=js"
export * from "./LogOut.vue?vue&type=script&lang=js"

import "./LogOut.vue?vue&type=style&index=0&id=5dedb299&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dedb299"]])

export default __exports__